import { type KeyboardInputAction } from "@/input/types";

import type { DocumentModel } from "@/models/DocumentModel";
import type { KeyCombination, Symbol } from "@corca/data";

export const selectionShortcuts = {
  "Shift+ArrowLeft": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel) => {
      const { cursor } = doc;
      if (doc.input.value.length > 0) {
        return false;
      }

      if (doc.matrixSelection.setupFromCursor(cursor, 0)) {
        doc.matrixSelection.moveSelection(-1, 0, (cell) => {
          cursor.moveTo(cell, 0);
        });

        return true;
      }

      doc.selection.selectLeft();
      return true;
    },
  },
  "Shift+ArrowRight": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel) => {
      const { cursor } = doc;
      if (doc.input.value.length > 0) {
        return false;
      }

      if (doc.matrixSelection.setupFromCursor(cursor, cursor.node?.nodes.length)) {
        doc.matrixSelection.moveSelection(1, 0, (cell) => {
          cursor.moveTo(cell, cell.nodes.length);
        });

        return true;
      }

      doc.selection.selectRight();
      return true;
    },
  },
  "Shift+ArrowUp": {
    action: (doc: DocumentModel) => {
      const { cursor } = doc;
      if (doc.input.value.length > 0) {
        return false;
      }

      if (doc.matrixSelection.setupFromCursor(cursor)) {
        doc.matrixSelection.moveSelection(0, -1, (cell) => {
          cursor.moveTo(cell, 0);
        });

        return true;
      }

      doc.selection.selectUp();
      return false;
    },
  },
  "Shift+ArrowDown": {
    action: (doc: DocumentModel) => {
      const { cursor } = doc;
      if (doc.input.value.length > 0) {
        return false;
      }

      if (doc.matrixSelection.setupFromCursor(cursor)) {
        doc.matrixSelection.moveSelection(0, 1, (cell) => {
          cursor.moveTo(cell, 0);
        });

        return true;
      }

      doc.selection.selectDown();
      return false;
    },
  },
  "Mod+Shift+ArrowLeft": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel) => {
      doc.cursor.moveToLineStart(true);
      return true;
    },
  },
  "Mod+Shift+ArrowRight": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel) => {
      doc.cursor.moveToLineEnd(true);
      return true;
    },
  },
  "Mod+KeyA": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel) => {
      doc.cursor.reset();
      doc.editor.tiptap?.chain().focus().selectDocument().run();
      return true;
    },
  },
  "Shift+Home": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel) => {
      doc.cursor.moveToLineStart(true);
      return true;
    },
  },
  "Shift+End": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel) => {
      doc.cursor.moveToLineEnd(true);
      return true;
    },
  },
  "Shift+Alt+ArrowLeft": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel): boolean => {
      return selectionShortcuts["Shift+ArrowLeft"].action(doc);
    },
  },
  "Shift+Alt+ArrowRight": {
    canPickSuggestion: () => false,
    action: (doc: DocumentModel): boolean => {
      return selectionShortcuts["Shift+ArrowRight"].action(doc);
    },
  },
} satisfies Partial<Record<KeyCombination | Symbol, KeyboardInputAction>>;
